/* ============================================================
   LS Gallery — "Load more".

   Each press reveals the next batch of images and leaves the
   button in place; it only removes itself once nothing is
   hidden any more. No backend.

   Galleries can also be grouped. A section holds at most 50
   blocks (Shopify platform limit), so a gallery bigger than
   that has to be split across sections. Give those sections
   the same "Gallery group" name and they behave as one grid:
   a single button walks through the hidden images of every
   section in the group, in document order. Sections with no
   group name are groups of one, which is the original
   behaviour.
   ============================================================ */

(function () {
  var DEFAULT_BATCH = 8;

  var sections = Array.prototype.slice.call(
    document.querySelectorAll('[data-section-type="ls-gallery"]')
  );
  if (!sections.length) return;

  // Bucket the sections: a shared, non-empty group name puts them together,
  // anything else stands on its own.
  var groups = [];
  var byName = {};

  sections.forEach(function (section) {
    var name = (section.getAttribute('data-lsgal-group') || '').trim();

    if (!name) {
      groups.push([section]);
      return;
    }

    if (!byName[name]) {
      byName[name] = [];
      groups.push(byName[name]);
    }
    byName[name].push(section);
  });

  function hiddenIn(group) {
    var items = [];
    group.forEach(function (section) {
      items = items.concat(
        Array.prototype.slice.call(section.querySelectorAll('.lsgal__item--hidden'))
      );
    });
    return items;
  }

  function removeButton(button) {
    var actions = button.closest('.lsgal__actions');
    if (actions) {
      actions.remove();
    } else {
      button.remove();
    }
  }

  groups.forEach(function (group) {
    var primaryGrid = group[0].querySelector('.lsgal__grid');

    if (primaryGrid && group.length > 1) {
      group.slice(1).forEach(function (section) {
        var grid = section.querySelector('.lsgal__grid');
        if (!grid || grid === primaryGrid) return;

        Array.prototype.slice.call(grid.children).forEach(function (item) {
          primaryGrid.appendChild(item);
        });
      });
    }

    var buttons = [];

    group.forEach(function (section) {
      var button = section.querySelector('[data-lsgal-load-more]');
      if (button) buttons.push(button);
    });

    if (!buttons.length) return;

    // Keep one button, drop the rest.
    var primary = buttons.filter(function (button) {
      return button.getAttribute('data-lsgal-bound') === 'true';
    })[0] || buttons[0];

    buttons.forEach(function (button) {
      if (button !== primary) removeButton(button);
    });

    // The button belongs under the whole group, not under the section that
    // happens to own it. Images fill the group top to bottom, so a button left
    // in the first section ends up stranded mid-gallery once that section is
    // full and the later ones start rendering beneath it.
    var actions = primary.closest('.lsgal__actions');
    var lastContainer = group[group.length - 1].querySelector('.container');

    if (actions && lastContainer && actions.parentNode !== lastContainer) {
      var footer = lastContainer.querySelector('.lsgal__footer');
      if (footer) {
        lastContainer.insertBefore(actions, footer);
      } else {
        lastContainer.appendChild(actions);
      }
    }

    var batch =
      parseInt(group[0].getAttribute('data-lsgal-batch'), 10) || DEFAULT_BATCH;

    if (primary.getAttribute('data-lsgal-bound') === 'true') return;
    primary.setAttribute('data-lsgal-bound', 'true');

    primary.addEventListener('click', function () {
      hiddenIn(group)
        .slice(0, batch)
        .forEach(function (item) {
          item.classList.remove('lsgal__item--hidden');
        });

      // Nothing left to show — the button has done its job.
      if (!hiddenIn(group).length) removeButton(primary);
    });
  });
})();
